import ShadedMap2 from '../../components/ShadedMap2';
import colors from '../../ui/colors';
import useOnboardingState from './useOnboardingState';
import { useMemo } from 'react';

const OnboardingMap: React.FC = () => {
  const { countries, bCountries } = useOnboardingState();
  const params = useMemo(() => {
    const primaryCountries = countries.map(code => ({ color: colors.chartreuse, countryCode: code }));
    const bucketlistCountries = bCountries.map(code => ({ color: colors.black, countryCode: code }));
    return [...primaryCountries, ...bucketlistCountries];
  }, [bCountries, countries]);
  return (
    // <ShadedMap selectedCountries={params}/>
    <ShadedMap2 selectedCountries={params} />
  );
};

export default OnboardingMap;
